import { cva as o, ct as n } from "@/styled-system/css";
const a = o({
  base: {
    display: "flex",
    justifyContent: "center",
    paddingBlock: n("Banner.spacing.padding.vert"),
    paddingInline: n("Banner.spacing.padding.horz"),
    textStyle: "body",
    borderRadius: n("Banner.radii"),
    '&:has([data-c11n-component="Banner.Close"]) [data-c11n-component="Banner.Icon"]': {
      marginInlineStart: "auto"
    }
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: n("Banner.colors.critical.bg"),
        color: n("Banner.colors.critical.text")
      },
      info: {
        backgroundColor: n("Banner.colors.info.bg"),
        color: n("Banner.colors.info.text")
      },
      success: {
        backgroundColor: n("Banner.colors.success.bg"),
        color: n("Banner.colors.success.text")
      },
      warning: {
        backgroundColor: n("Banner.colors.warning.bg"),
        color: n("Banner.colors.warning.text")
      }
    }
  }
});
export {
  a as bannerRecipe
};
//# sourceMappingURL=banner-root.styles.js.map
